import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_view_group_products",
  tabindex: -1,
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content p-5" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_7 = {
  key: 1,
  class: "badge badge-light-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h2", null, _toDisplayString(`${_ctx.$t('message.PRODUCTS')}`), 1),
          _hoisted_5
        ]),
        _createVNode(_component_Table, {
          columns: _ctx.columns,
          rows: _ctx.products,
          padding: 5,
          pagination: _ctx.pagination,
          loading: _ctx.loader,
          onHandleCurrentChange: _ctx.handleCurrentChange
        }, {
          "cell-status": _withCtx(({ row: item }) => [
            (item?.status == 1)
              ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('message.ACTIVE')), 1))
              : (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('message.INACTIVE')), 1))
          ]),
          "cell-name": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(_ctx.productDisplayName(item)), 1)
          ]),
          _: 1
        }, 8, ["columns", "rows", "pagination", "loading", "onHandleCurrentChange"])
      ])
    ])
  ]))
}